"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var SvgUsersSvg = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ className: "UsersSVG_svg__stroke-current", fill: "none", height: 23, width: 24, xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5 }, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M16.78 10.114a3.92 3.92 0 1 0 0-7.842", opacity: 0.4 }), (0, jsx_runtime_1.jsx)("path", { d: "M18.584 14.375c.647.044 1.289.137 1.923.277.879.175 1.937.535 2.313 1.324.24.505.24 1.094 0 1.6-.375.788-1.434 1.148-2.313 1.329" }), (0, jsx_runtime_1.jsxs)("g", __assign({ clipRule: "evenodd", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M9.136 15.22c4.388 0 8.136.664 8.136 3.32 0 2.656-3.724 3.344-8.136 3.344-4.389 0-8.136-.664-8.136-3.32 0-2.657 3.723-3.345 8.136-3.345z" }), (0, jsx_runtime_1.jsx)("path", { d: "M9.135 11.428a5.195 5.195 0 0 1-5.213-5.214A5.195 5.195 0 0 1 9.135 1a5.196 5.196 0 0 1 5.215 5.214 5.196 5.196 0 0 1-5.215 5.214z", opacity: 0.4 })] }))] })) }))); };
exports.default = SvgUsersSvg;
